// extracted by mini-css-extract-plugin
export var danger = "_36-6";
export var lightPink = "_36-a";
export var medium = "_36-j";
export var nearSquare = "_36-m";
export var neutralBlue = "_36-8";
export var neutralYellow = "_36-7";
export var noCapitalize = "_36-1";
export var normal = "_36-2";
export var pill = "_36-0";
export var primary = "_36-3";
export var primaryLight = "_36-4";
export var shadow = "_36-n";
export var small = "_36-k";
export var solidBlack = "_36-i";
export var solidGreen = "_36-d";
export var solidLightBlue = "_36-f";
export var solidNavy = "_36-e";
export var solidOrange = "_36-h";
export var solidPink = "_36-g";
export var solidRed = "_36-b";
export var solidWhite = "_36-9";
export var solidYellow = "_36-c";
export var success = "_36-5";
export var xsmall = "_36-l";